import { Grid, GridItem, Switch, Text } from "@chakra-ui/react";
import React from "react";
import CustomInput from "../../../components/UI/CustomInput";

export default function Status({ payload, setPayload, errors = {}, validateRequiredField }) {
  return (
    <Grid className="status-modal-grid" templateColumns="140px 1fr 1fr">
      <GridItem className="status-modal-username" colSpan={3}>
        <Text>{payload?.user?.username}</Text>
      </GridItem>
      <GridItem className="status-modal-control" gridColumn="2">
        <Text fontSize="sm">User Active</Text>
        <Switch
          name="isActive"
          defaultChecked={payload?.user?.isActive}
          onChange={(e) =>
            setPayload({
              ...payload,
              isActive: e.target.checked,
            })
          }
        />
      </GridItem>
      <GridItem className="status-modal-control" gridColumn="3">
        <Text fontSize="sm">Bet Active</Text>
        <Switch
          name="isBetActive"
          defaultChecked={!payload?.user?.isBetLocked}
          onChange={(e) =>
            setPayload({
              ...payload,
              isBetActive: !e.target.checked,
            })
          }
        />
      </GridItem>
      <GridItem className="simple-modal-label">
        <Text>Transaction Password</Text>
      </GridItem>
      <GridItem colSpan={2}>
        <CustomInput
          required
          minLength={6}
          error={errors.transactionPassword}
          onFocus={() => validateRequiredField("transactionPassword", "The Transaction Code field is required")}
          type="password"
          value={payload?.transactionPassword}
          name="client-status-transaction-code"
          autoComplete="new-password"
          onChange={(e) =>
            setPayload({ ...payload, transactionPassword: e.target.value })
          }
        />
      </GridItem>
    </Grid>
  );
}
